export default __webpack_public_path__ + "static/media/9.2bf4bd41.svg";